import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllBillListing, getBillingDetail, submitConfirmation, updateAmount } from '../../Redux/Actions/BillingsActions';
import { capitalizeFirstLetter } from '../../Utils/helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../../Common/Loader';

const BillingListing = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { id } = useParams()
    const location = useLocation();
    // const { billingData } = location.state || {};
    const { pagination } = location.state || {}

    const queryParams = new URLSearchParams(location.search);
    const mode = queryParams.get("mode"); // 'view
    const billingdetailData = useSelector((state) => state?.BillingDataSlice?.getBillingDetail)
    const ClientData = useSelector((state) => state?.BillingDataSlice?.getAllBillingData?.data)
    const isLoading = useSelector((state) => state?.BillingDataSlice?.isLoading)

    const matchedItem = ClientData?.find(item => item?.id === Number(id));

    const status = matchedItem?.status || "Not Found";
    const [loading, setLoading] = useState(false)
    const [editableBillingData, setEditableBillingData] = useState([]);

    const [page, setPage] = useState(pagination?.current_page || 1);
    const [updatingAmountIds, setUpdatingAmountIds] = useState([]);
    const [isEditingAmount, setIsEditingAmount] = useState(true);


    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleFieldChange = (id, field, value) => {
        setEditableBillingData((prev) =>
            prev.map((item) =>
                item.id === id ? { ...item, [field]: value } : item
            )
        );
    };


    useEffect(() => {
        if (id && billingdetailData?.billing_data?.length > 0) {
            setEditableBillingData(billingdetailData.billing_data.map((item) => ({ ...item })));
        } else {
            setEditableBillingData([]); // clear on unmount or empty
        }
    }, [id, billingdetailData]);


    const handleFinalzedAmount = () => {
        const updates = editableBillingData
            .filter((editedItem, index) => {
                const originalItem = billingdetailData?.billing_data[index];
                return (
                    String(editedItem.amount) !== String(originalItem.amount)
                );
            })
            .map(item => ({
                id: item.id,
                amount: Number(item.amount),

            }));

        if (updates.length === 0) {
            toast.info("No changes to Finalise.");
            return;
        }
        const payload = { updates, billing_id: billingdetailData?.id };
        setLoading(true)
        dispatch(updateAmount(payload)).then((res) => {
            if (res?.type === "update-amount/fulfilled") {
                toast.success(res?.payload?.message)
                setLoading(false)
                dispatch(getAllBillListing({ page }))
            } else {
                toast.error("Error occured")
                setLoading(false)
            }
        })
    }

    const handleCompleteFilling = () => {
        const updates = editableBillingData
            .filter((editedItem, index) => {
                const originalItem = billingdetailData?.billing_data[index];
                return (
                    String(editedItem.confirmation_id) !== String(originalItem.confirmation_id) ||
                    String(editedItem.notes) !== String(originalItem.notes)

                );
            })
            .map(item => ({
                id: item.id,
                confirmation_id: item?.confirmation_id,
                notes: item?.notes
            }));

        if (updates.length === 0) {
            toast.info("No changes to Complete Filling.");
            return;
        }
        const payload = { updates, billing_id: billingdetailData?.id };
        dispatch(submitConfirmation(payload)).then((res) => {
            if (res?.type === "submit-confirmation/fulfilled") {
                toast.success(res?.payload?.message)
                navigate('/dashboard/billinglisting')
                dispatch(getBillingDetail(id));  // Refresh the billing details
                dispatch(getAllBillListing({ page }));

            } else {
                toast.error("Error Occured")
            }
        })
    }


    const handleAmountBlur = (id) => {
        const editedItem = editableBillingData.find((item) => item.id === id);
        const originalItem = billingdetailData?.billing_data?.find((item) => item.id === id);

        if (!editedItem || !originalItem) return;
        if (String(editedItem.amount) === String(originalItem.amount)) return;

        setUpdatingAmountIds((prev) => [...prev, id]);

        const updates = [{ id, amount: Number(editedItem.amount) }];

        dispatch(updateAmount({ updates, billing_id: billingdetailData?.id })).then((res) => {
            if (res?.type !== "update-amount/fulfilled") {
                toast.error("Error occurred while updating amount.");
            }
            setUpdatingAmountIds((prev) => prev.filter((uid) => uid !== id));
        });
    };

    const handleEditAmount = () => {
        setIsEditingAmount(false)
    }

    useEffect(() => {
        if (id) {
            dispatch(getBillingDetail(id))
            dispatch(getAllBillListing({ page: page }))
        }
    }, [id])

    return (
        <div>
            {(isLoading || loading) && <Loader />}
            <div className="pt-3 px-2 pb-6 bg-gray-100 min-h-screen font-sans">
                <div className=" mx-auto bg-white rounded-lg shadow-md overflow-hidden">
                    <div className="p-4">
                        <div className="flex items-center space-x-2">
                            <button onClick={() => navigate("/dashboard/billinglisting")}
                                className="px-2 rounded-full hover:bg-gray-200 transition"
                                aria-label="Go back"
                            >
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                            <h2 className="text-2xl font-semibold text-gray-800 mb-0">Medicaid Billing</h2>
                        </div>
                    </div>
                    <div className='flex justify-end px-4 mb-3'>
                        {mode === 'view' ? (
                            <></>
                        ) : (
                            <>
                                {status === "open" && (
                                    <button onClick={handleFinalzedAmount}
                                        className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md shadow-md transition duration-300 ease-in-out flex items-center space-x-2">
                                        Finalize</button>
                                )}

                                {(status === "ready_for_filling") && (
                                    <>
                                        {isEditingAmount ? (
                                            <>
                                                <button onClick={handleEditAmount}
                                                    className="mr-2 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg shadow-sm transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-400"
                                                >Edit Amount</button>
                                                <button onClick={handleCompleteFilling}
                                                    className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-sm transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-green-400"
                                                >Complete Filing</button>
                                            </>
                                        ) : (
                                            <>
                                                <button onClick={handleFinalzedAmount}
                                                    className=" mr-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md shadow-md transition duration-300 ease-in-out flex items-center space-x-2"

                                                >Finalize</button>
                                                <button onClick={handleCompleteFilling}
                                                    className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-sm transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-green-400"
                                                >Complete Filing</button>
                                            </>
                                        )}
                                    </>
                                )}

                                {status === "filing_done" && (
                                    <>
                                        {isEditingAmount ? (
                                            <>
                                                <button>Edit</button>
                                                <button >Complete Filing</button>
                                            </>
                                        ) : (
                                            <>
                                                <button onClick={handleFinalzedAmount}
                                                    className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md shadow-md transition duration-300 ease-in-out flex items-center space-x-2"

                                                >Finalize</button>
                                                <button>Complete Filing</button>
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}

                    </div>
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Name
                                    </th>
                                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Plan
                                    </th>
                                    <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Member ID
                                    </th>
                                    <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        SSN
                                    </th>
                                    <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Month
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        year
                                    </th>
                                    <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Provider
                                    </th>
                                    <th scope="col" className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Type
                                    </th>
                                    <th scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Status
                                    </th>
                                    <th scope="col"
                                        className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        Amount
                                    </th>
                                    {(status === "ready_for_filling" || status === "filing_done" || status === "done" || mode === "view") && (
                                        <th scope="col"
                                            className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            confirmation ID
                                        </th>
                                    )}

                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        <div className="flex items-center">
                                            Notes
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="ml-1 h-3 w-3 text-gray-400"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                            </svg>
                                        </div>
                                    </th>
                                </tr>
                            </thead>

                            <tbody className="bg-white divide-y divide-gray-200">
                                {billingdetailData && billingdetailData?.billing_data?.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="pl-3 py-3 whitespace-nowrap text-sm text-gray-900">{capitalizeFirstLetter(item?.members?.name)}</td>
                                            <td className="pl-3 py-3 whitespace-nowrap text-sm text-gray-900">{capitalizeFirstLetter(item?.plan)}</td>
                                            <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500">{item?.members?.member_id}</td>
                                            <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500">{item?.members?.ssn}</td>
                                            <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500">{capitalizeFirstLetter(billingdetailData?.month)}</td>
                                            <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">{billingdetailData?.year}</td>
                                            <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-500">{capitalizeFirstLetter(billingdetailData?.provider?.name) || "--"}</td>
                                            <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500">{capitalizeFirstLetter(billingdetailData?.type?.name) || "--"}</td>
                                            {/* <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-500">${item?.amount}</td> */}
                                            <td className="px-3 py-3 whitespace-nowrap text-sm font-medium text-center">
                                                <span className={`px-2 py-1 rounded-full text-xs font-semibold 
                                                ${item?.status === "paid"
                                                        ? "text-green-700 bg-green-100"
                                                        : "text-red-700 bg-red-100"}`}>
                                                    {capitalizeFirstLetter(item?.status)}
                                                </span>
                                            </td>
                                            <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500">
                                                <div className="relative w-28">
                                                    $ <input
                                                        type="number"
                                                        className={`border border-gray-300 rounded px-2 py-1 pr-6 w-full ${updatingAmountIds.includes(item.id) ? 'text-gray-400' : ''
                                                            }`}
                                                        value={editableBillingData.find(d => d.id === item.id)?.amount || ""}
                                                        onChange={(e) => handleFieldChange(item.id, 'amount', e.target.value)}
                                                        onBlur={() => handleAmountBlur(item?.id)}
                                                        disabled={(isEditingAmount && status !== "open") || mode}
                                                    />
                                                    {updatingAmountIds.includes(item.id) && (
                                                        <div className="absolute right-2 top-1/2 -translate-y-1/2">
                                                            <svg className="w-4 h-4 animate-spin text-blue-500" fill="none" viewBox="0 0 24 24">
                                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                                                            </svg>
                                                        </div>
                                                    )}
                                                </div>

                                            </td>
                                            {(status === "ready_for_filling" || status === "filing_done" || status === "done" || mode === "view") && (
                                                <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500">
                                                    <textarea
                                                        type="text"
                                                        className="border border-gray-300 rounded px-2 py-1 w-48"
                                                        value={editableBillingData.find(d => d.id === item.id)?.confirmation_id || ""}
                                                        onChange={(e) => handleFieldChange(item.id, 'confirmation_id', e.target.value)}
                                                        rows={2}
                                                        disabled={mode}
                                                    />
                                                </td>
                                            )}

                                            <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500">
                                                <textarea
                                                    className="border border-gray-300 rounded px-2 py-1 w-48"
                                                    value={editableBillingData.find((d) => d.id === item.id)?.notes || ""}
                                                    onChange={(e) => handleFieldChange(item.id, 'notes', e.target.value)}
                                                    rows={2}
                                                    disabled={mode}
                                                />
                                            </td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                        {/* <div className="px-6 border-t border-gray-200 flex items-center justify-between">
                            <div className="flex-1 flex justify-between sm:hidden">
                                <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">Previous</a>
                                <a href="#" className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">Next</a>
                            </div>
                            <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between pb-4">
                                <div>
                                    <p className="text-sm text-gray-700">
                                        Showing <span className="font-medium">{pagination?.from}</span> to <span className="font-medium">{pagination?.to}</span> of <span className="font-medium">{pagination?.total}</span> results
                                    </p>
                                </div>
                                <div>
                                    <Pagination
                                        count={pagination?.last_page}  // total pages
                                        page={page}         // current page
                                        onPageChange={handlePageChange}  // handler
                                    />
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BillingListing;
